export default {
  GET(state, data) {
    state.organization = data
  },
  LIST(state, data) {
    state.organizations = data
  },
  MINISTRIES(state, data) {
    state.ministries = data
  },
  UPDATE(state, value) {
    state.organization = { ...value }
  },
  FRESH(state) {
    state.organization = {
      id: null,
      name: {
        uz: '',
        ru: '',
        en: '',
      },
      short_name: {
        uz: '',
        ru: '',
        en: '',
      },
      address: '',
      tel: '',
      inn: '',
      parent_id: null,
      type_org_id: null,
      region: null,
    }
  },
}
